import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import Cookies from 'universal-cookie';
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';

const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/"; //pasar id del estudiante
const idAdministrativo = cookie.get("idAdministrativo");    //declaramos una variable para usar la cookie del login


class SidebarDirectorTitulacion extends Component {

    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                //console.log(estudiante);
                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })
            })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (

            <div id="layoutSidenav_nav" style={{ width: 226 }}>
                <nav
                    className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft"
                    id="sidenavAccordion"
                >
                    <div className="sb-sidenav-menu px-2 pt-3">
                        <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                            <p className="text-white">Personal de Director de Titulación</p>
                        </div>

                        {/* Página Principal */}
                        <Link to="/directortitulacion" className="nav-link-custom">
                            <i className="fas fa-home me-2"></i>
                            Página Principal
                        </Link>

                        {/* Tipos de Titulación */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseTiposTitulacion"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-graduation-cap me-2"></i>
                                    Gestión de tipos de titulación
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseTiposTitulacion">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/directortitulacion/listartipostitulacion"
                                        className="nav-sub-link"
                                    >
                                        Tipos de Titulación
                                    </Link>
                                </nav>
                            </div>
                        </div>

                        {/* Estados de los Documentos */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseEstados"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-file-alt me-2"></i>
                                    Gestión de documentos
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseEstados">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/directortitulacion/estadosdocumenttitu"
                                        className="nav-sub-link"
                                    >
                                        Gestión de estados de los documentos
                                    </Link>

                                    <Link
                                        to="/directortitulacion/documentostitulacion"
                                        className="nav-sub-link"
                                    >
                                        Gestión de documentos
                                    </Link>

                                </nav>
                            </div>
                        </div>

                        {/* Gestión de Titulación */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseGestionTitulacion"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-user-graduate me-2"></i>
                                    Gestión de Titulación
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseGestionTitulacion">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/directortitulacion/asigtutorestud"
                                        className="nav-sub-link"
                                    >
                                        Asignar Tutor-Estudiante
                                    </Link>
                                    <Link
                                        to="/directortitulacion/reportestudtipotitul"
                                        className="nav-sub-link"
                                    >
                                        Reporte de estudiantes por tipo titulación
                                    </Link>
                                    <Link
                                        to="/directortitulacion/reportestudtitulcarrera"
                                        className="nav-sub-link"
                                    >
                                        Reporte de estudiantes por carrera
                                    </Link>

                                </nav>
                            </div>


                        </div>

                        {/* Gestión de Calificaciones */}
                        <div className="nav-section">
                            <div
                                className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                                data-bs-toggle="collapse"
                                data-bs-target="#collapseCalificaciones"
                                aria-expanded="false"
                            >
                                <span>
                                    <i className="fas fa-clipboard-list me-2"></i>
                                    Gestión de Calificaciones
                                </span>
                                <i className="fas fa-chevron-down small"></i>
                            </div>
                            <div className="collapse" id="collapseCalificaciones">
                                <nav className="nav flex-column ms-3">
                                    <Link
                                        to="/directortitulacion/tiposcalificaciones"
                                        className="nav-sub-link"
                                    >
                                        Tipos de Calificaciones
                                    </Link>
                                </nav>
                            </div>
                        </div>
                    </div>

                    <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                        Usuario:<br />
                        {cookie.get("nombres")} {cookie.get("apellidos")}
                    </div>
                </nav>
            </div>
        )
    }
}

export default withRouter(SidebarDirectorTitulacion);